module.exports = __webpack_public_path__ + "media/MRI5.017743ff.mp3";